<template>
    <div class="link-title">
        <div class="link" :style="{ backgroundColor: linkClass }"></div>
        <h2>
            {{ $t(title) }}
        </h2>
    </div>
</template>
<script>
export default {
    name: 'LinkTitle',
    props: {
        title: String,
        linkClass: String
    }
}
</script>

<style lang="less" scoped>
.link-title {
    display: flex;
    align-items: flex-end;
    margin: 2vw 0 1vw;
    h2 {
        font-weight: bold;
        font-size: 1.2vw;
        line-height: 1.2vw;
        letter-spacing: .1vw;
    }
    .link {
        display: inline-block;
        width: .2vw;
        height: 1.6vw;
        background-color: #d01814;
        margin-right: .5vw;
    }
}
@media screen and (max-width: 940px) {
    .link-title {
    display: flex;
    align-items: flex-end;
    margin: 2vw 0 1vw;
    
    h2 {
        font-weight: bold;
        font-size: 2.4vw;
        line-height: 2.4vw;
        letter-spacing: .1vw;
   
    }
    .link {
        display: inline-block;
        width: .2vw;
        height: 3vw;
        background-color: #d01814;
        margin-right: .5vw;
    }
}
}

</style>